import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {defineMessage} from '../../../../../libs/shared/core/src/helpers/internationalization/message';
import {Input, InputTypesEnum} from '../../../../../libs/shared/ui/src/components/inputs/input';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {CommentModel} from '../../../../models/api/commentModel';

/*
 * Constants.
 */

export const internalTopicEditorPlaceholder = 'Add a subject';

/*
 * Props.
 */

export interface InternalTopicEditorProps {
  comment: CommentModel;
  onTopicChange: (arg: string) => void;
  onTopicBlur: () => void;
}

/*
 * Style.
 */

const StyledTopicInput = styled(Input)`
  &::placeholder {
    color: ${(p) => p.theme.greys.shade50};
  }

  padding: 6px 16px;
  width: 100%;

  color: ${(p) => p.theme.greys.shade80};
  font-size: ${fontSizes.veryLarge};
  font-weight: ${fontWeights.bold};
  line-height: 34px;
`;

/*
 * Component.
 */

export const InternalTopicEditor: FC<InternalTopicEditorProps> = (props) => {
  const localize = useLocalize();

  // Input state.
  const [topic, setTopic] = useState(props.comment.topic || '');

  // On change, debounce the update.
  const onInputChange = (newTopic: string) => {
    props.onTopicChange(newTopic);
    setTopic(newTopic);
  };

  return (
    <StyledTopicInput
      type={InputTypesEnum.TEXT}
      value={topic}
      onChange={onInputChange}
      onBlur={props.onTopicBlur}
      placeholder={localize(
        defineMessage({
          id: 'internal-discussion-subject',
          message: internalTopicEditorPlaceholder,
        }),
      )}
    />
  );
};
